export const initFAQElemental = () => {
    const faqItems = document.querySelectorAll('.faqs .accordion-item');
    if (!faqItems.length) return;

    //the toggle btn
    faqItems.forEach((item) => {
        const toggleBtn = item.querySelector('.faqs .collapsed');
        const answer = item.querySelector('.faqs .collapse');

        if (!toggleBtn && !answer) return;

        // Show answer when toggling the question toggleBtn
        toggleBtn.addEventListener('click', () => {
            const isOpen = answer.classList.contains('show');

            if (isOpen) {
                toggleBtn.classList.add('collapsed');
                answer.classList.remove('show');
            } else {
                toggleBtn.classList.remove('collapsed');
                answer.classList.add('show');
            }
        });
    });
};
